import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import React from "react";
import { useModal } from "hooks/useModal";
import ThreeDots from "static/images/ThreeDots.svg";
import ShareHolderDelete from "./ShareHolderDelete";
import { AddShareholder } from "./AddShareholder";
import { Shareholder } from "types/Models/Shareholders";

const ShareholderAction = ({
  shareholder,
  onViewDetails,
  onEditPersona,
}: {
  shareholder: Shareholder;
  onViewDetails: (shareholder: Shareholder) => void;
  onEditPersona: (shareholder: Shareholder) => void;
}) => {
  const deleteModal = useModal();
  const editEntityModal = useModal();
  const isPersona = shareholder.shareholder_type === "PERSONA";

  const handleEdit = () => {
    if (isPersona) {
      onEditPersona(shareholder);
    } else {
      editEntityModal.open();
    }
  };

  return (
    <>
      <Dropdown.Root>
        <Dropdown.Trigger asChild>
          <img
            src={ThreeDots}
            alt="options"
            onClick={(event) => event.stopPropagation()}
          />
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content
            sideOffset={6}
            align="end"
            onClick={(event) => event.stopPropagation()}
          >
            <Dropdown.Item
              key="view"
              onSelect={() => setTimeout(() => onViewDetails(shareholder), 0)}
            >
              View details
            </Dropdown.Item>
            <Dropdown.Item
              key="Edit"
              onSelect={() => setTimeout(handleEdit, 0)}
            >
              Edit
            </Dropdown.Item>
            <Dropdown.Item
              key="delete"
              type="danger"
              onSelect={() => setTimeout(() => deleteModal.open(), 0)}
            >
              Delete
            </Dropdown.Item>
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
      <ShareHolderDelete shareholderId={shareholder.uuid} {...deleteModal} />
      {!isPersona && (
        <AddShareholder {...editEntityModal} shareholder={shareholder} />
      )}
    </>
  );
};

export default ShareholderAction;
